import React from "react";

const labels = ["Learn", "Refine", "Standardize", "Execute", "Improve"];
const radius = 185;
const point = (angle: number) => ({ x: 260 + radius * Math.cos(angle), y: 260 + radius * Math.sin(angle) });
const angles = labels.map((_, i) => (i * 72 - 90) * Math.PI / 180);
// Signed distance to each rounded label box, matching the SVG dimensions.
const distance = (angle: number, center: { x: number; y: number }) => {
  const p = point(angle);
  const dx = Math.abs(p.x - center.x) - 54;
  const dy = Math.abs(p.y - center.y) - 12;
  return Math.hypot(Math.max(dx, 0), Math.max(dy, 0)) + Math.min(Math.max(dx, dy), 0) - 12;
};
const boundary = (angle: number, direction: number) => {
  const center = point(angle);
  let low = 0, high = Math.PI / 5;
  for (let i = 0; i < 40; i++) {
    const mid = (low + high) / 2;
    if (distance(angle + direction * mid, center) < 9) low = mid;
    else high = mid;
  }
  return angle + direction * (low + high) / 2;
};

const EngineeringEvolution: React.FC = () => (
  <div className="eng-loop">
    <svg viewBox="0 0 520 520" role="img" aria-label="Continuous engineering evolution: Learn, Refine, Standardize, Execute, Improve, then back to Learn">
      <defs>
        <marker id="eng-cycle-arrow" viewBox="0 0 10 10" refX="10" refY="5" markerWidth="10" markerHeight="10" markerUnits="userSpaceOnUse" orient="auto">
          <path d="M0 0L10 5L0 10Z" fill="#a17dff" />
        </marker>
      </defs>
      {angles.map((angle, i) => {
        const next = angle + 2 * Math.PI / 5;
        const start = point(boundary(angle, 1));
        const end = point(boundary(next, -1));
        return <path key={`arrow-${i}`} d={`M ${start.x} ${start.y} A ${radius} ${radius} 0 0 1 ${end.x} ${end.y}`} stroke="#a17dff" strokeWidth="1.7" fill="none" markerEnd="url(#eng-cycle-arrow)" />;
      })}
      {labels.map((label, i) => {
        const p = point(angles[i]);
        return <g key={label}>
          <rect x={p.x - 66} y={p.y - 24} width="132" height="48" rx="12" fill="#171126" stroke="#a17dff88" />
          <text x={p.x} y={p.y + 5} textAnchor="middle" fill="#eee8fb" fontSize="16">{label}</text>
        </g>;
      })}
      <text x="260" y="255" textAnchor="middle" fill="#c9b3ee" fontSize="19">Continuous</text>
      <text x="260" y="280" textAnchor="middle" fill="#c9b3ee" fontSize="19">Engineering Evolution</text>
    </svg>
  </div>
);
export default EngineeringEvolution;
